/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamTypeCategoryDto
 */
export interface CreateUpdateExamTypeCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeCategoryDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamTypeCategoryDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateExamTypeCategoryDto interface.
 */
export function instanceOfCreateUpdateExamTypeCategoryDto(value: object): value is CreateUpdateExamTypeCategoryDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function CreateUpdateExamTypeCategoryDtoFromJSON(json: any): CreateUpdateExamTypeCategoryDto {
    return CreateUpdateExamTypeCategoryDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamTypeCategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamTypeCategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
    };
}

export function CreateUpdateExamTypeCategoryDtoToJSON(value?: CreateUpdateExamTypeCategoryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'active': value['active'],
    };
}

